import styled from '@emotion/styled'
import { calcRem, zIndex } from '../../../__styling'
import { colorsPN } from '@news-mono/design-tokens'
import { PNVideoPlayButtonProps } from './PNVideoPlayButton'
import { PNCardOverlayButtonScale } from '../cards/PNArticleCard'

export const StyledPNVideoPlayButton = styled.button<PNVideoPlayButtonProps>(
    ({ overlayButtonScale = 'M' }) => {
        const iconStyle = getPlayIconStyle(overlayButtonScale)

        return {
            background: colorsPN.fill.weak,
            transition: 'all .25s ease-in-out',
            border: 'none',
            cursor: 'pointer',

            position: 'absolute',
            height: calcRem(iconStyle.size),
            width: calcRem(iconStyle.size),
            borderRadius: `${iconStyle.size / 2}px`,
            left: calcRem(iconStyle.marginLeft),
            bottom: calcRem(iconStyle.marginBottom),
            zIndex: zIndex.common.videoPlayButton,

            '&:hover': {
                background: colorsPN.background.brand.strong,
            },

            svg: {
                transform: `translateY(${calcRem(iconStyle.svgOffset)})`,
                width: calcRem(iconStyle.svgWidth),
            },
        }
    },
)

// To decide the button size defined here: https://www.figma.com/design/3veq2RFYCAfwUqTSUuHln8/PerthNow-Design-System?node-id=436-74788&node-type=frame&m=dev
function getPlayIconStyle(overlayButtonScale: PNCardOverlayButtonScale) {
    switch (overlayButtonScale) {
        case 'L':
            return {
                size: 64,
                marginLeft: 21,
                marginBottom: 17,
                svgWidth: 32,
                svgOffset: 2,
            }
        case 'S':
            return {
                size: 30,
                marginLeft: 8,
                marginBottom: 5,
                svgWidth: 16,
                svgOffset: -2,
            }
        default:
            return {
                size: 48,
                marginLeft: 16,
                marginBottom: 13,
                svgWidth: 22,
                svgOffset: 2,
            }
    }
}
